import { Activation } from '@modules/activation/model';

export namespace ActivationUtils {
  export function mapFormToParams(body: Activation.Form): Activation.Params {
    return {
      password: body.password,
    };
  }
}
